// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1w2RH","label":"Completed_label__3loxn"};